export class CategoryResponse {
	children: CategoryChildrenResponse[] = [];
	name: string;
	description: string;
	id: number;
	active: boolean;

	constructor() {

	}
}

export class CategoryProfitRequest {
	category: number;
	profit: number;
	priceList: number;

	constructor(category: number, profit: number, priceList: number) {
		this.category = category;
		this.profit = profit;
		this.priceList = priceList;
	}
}

export class CategoryChildrenResponse {
	id: number;
	metaCategoryId: number;
	name: string;
	description: string;
	company: number;
	parent: number;
	active: boolean;

	constructor() {

	}
}

export class CategoryParentRequest {
	name: string;
	description: string;
	constructor() {

	}
}

export class CategoryChildRequest {
	name: string;
	description: string;
	parent: number;
	constructor() {

	}
}

export class CategoryVendorResponse {
	accountId: number;
	active: boolean;
	companyId: number;
	creationDate: number;
	id: number;
	name: string;
	validated: boolean;
	//for frontend
	validating!: boolean;
	changing!: boolean;
}